import React from "react";
import { resolveNavLabel } from "../../util/Util";

const NavLabel = ({ name, t, className, as: Tag = "span", ...props }) => {
	const { full, display } = resolveNavLabel(name, t);
	return (
		<Tag
			className={className}
			title={full !== display ? full : undefined}
			{...props}
		>
			{display}
		</Tag>
	);
};

export default NavLabel;
